<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">Proposta Enviada</h3>
  </div>
  <div class="modal-body">
    <span class="subtitle">
      Lembre-se que o cliente ainda precisa realizar o processo de Biometria e
      Privacidade.
    </span>

    <span>
      O <b>link será enviado por SMS</b> e basta o cliente seguir o passo a
      passo descrito nas telas para <b>finalizar as etapas do processo</b>.
    </span>

    <span>
      Depois de finalizado, a proposta estará em mãos do nosso
      <b> especialista Omni que entrará em contato pelos dados cadastrados </b>.
    </span>

    <span>
      Você também pode acompanhar o
      <b> andamento das suas propostas através da nossa timeline </b>.
    </span>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="marginT30 form-group tab-buttons">
        <a
          class="bt-back btn btn-border-orange"
          (click)="onAction(false)"
          >Voltar para home</a
        >
      </div>
    </div>
  </div>
</div>
